import DOMPurify from "dompurify";

export function Purify(texte: string) {
  return DOMPurify.sanitize(texte);
}
